import {
  FETCH_BROKER,
  FETCH_BROKER_SUCCESS,
  FETCH_BROKER_FAILED
} from "../store/types";

export const INITIAL_STATE = {
  broker: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
};

export const brokerreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BROKER:
      return {
        ...state,
        loading: true
      };
    case FETCH_BROKER_SUCCESS:
      return {
        ...state,
        broker: action.payload,
        loading: false
      };
    case FETCH_BROKER_FAILED:
      return {
        ...state,
        broker: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    default:
      return state;
  }
};
